module.exports = __webpack_public_path__ + "img/content8.fe07fbcd.png";